import React from "react";
import Query from "./component/Query";
import ARTICLES_QUERY from "./queries/articles/articles";
import Articles from "./component/Articles";
import Articles1 from "./component/Articles/article1";
import Articles2 from "./component/Articles/article2";
import Footer from "./component/Footer";

function Blog() {
  return (
    <div className="blog">
      <section className="pt-16">
        <div className="flex justify-center items-center w-full relative">
          <div>
            <Query query={ARTICLES_QUERY}>
              {({ data: { articles } }) => {
                return <Articles2 articles={articles} />;
              }}
            </Query>
          </div>
        </div>
      </section>

      <section className="mx-2 lg:mx-9">
        <h2 className="text-black text-3xl mb-10 lg:mb-28 lg:text-4xl pt-6 md:pt-11 font-bold font-nunito  text-center">
          WELCOME TO OUR BLOGS
        </h2>
        <div>
          <Query query={ARTICLES_QUERY}>
            {({ data: { articles } }) => {
              return <Articles articles={articles} />;
            }}
          </Query>
        </div>

        <h3 className="text-black mx-2 lg:mx-9 text-3xl mb-10 lg:text-3xl pt-6 md:pt-11 font-bold text-left">
          Where To Use Panelo's Product?
        </h3>
        <div>
          <Query query={ARTICLES_QUERY}>
            {({ data: { articles } }) => {
              return <Articles1 articles={articles} />;
            }}
          </Query>
        </div>

        <div className="mt-20">
          <Query query={ARTICLES_QUERY}>
            {({ data: { articles } }) => {
              return <Articles articles={articles} />;
            }}
          </Query>
        </div>
        <div className="mb-16">
          <h3 className="text-black mx-2 lg:mx-9 text-3xl mb-10 lg:text-3xl pt-6 md:pt-11 font-bold text-left">
            Where To Use Panelo's Product?
          </h3>
          <Query query={ARTICLES_QUERY}>
            {({ data: { articles } }) => {
              return <Articles1 articles={articles} />;
            }}
          </Query>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Blog;
